// extracted by mini-css-extract-plugin
export var flexContainer = "header-module--flex-container--sTwFV";
export var header = "header-module--header--4dQNe";
export var logo = "header-module--logo--WAoX3";
export var siteTitle = "header-module--site-title--a84zz";